import { socialLogin, socialSignup } from "@/social/index.js";

const Google = {
  async makeReq(googleUser) {
    return {
      name: googleUser.getBasicProfile().getName(),
      id: googleUser.getBasicProfile().getId(),
      email: googleUser.getBasicProfile().getEmail(),
      social: "google",
    };
  },

  async login(googleUser, callback) {
    const req = await this.makeReq(googleUser);
    const [flag, data] = await socialLogin(req);

    if (typeof callback === "function") {
      callback(req, flag, data);
    }
  },

  async signup(googleUser, callback) {
    const req = await this.makeReq(googleUser);
    const [flag, data] = await socialSignup(req);

    if (typeof callback === "function") {
      callback(req, flag, data);
    }
  },
};

export default Google;
